import agent from "./agent";
import { ApiFactory } from "./ApiFactory";

export default class PreAuthApi {
    private apiFactory: ApiFactory;

    constructor(apiFactory: ApiFactory) {
        this.apiFactory = apiFactory;
    }

    getPreAuthHistory = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaimpreauth/GetList`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    getDetailsByPreAuth = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaimpreauth/GetPreAuth`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    getDetailsByHin = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaimpreauth/GetDetailsFromHin`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    saveWarrantyPreAuth = async (params: any) => {
        try {
            const response = await agent.api.post(`/warrantyclaimpreauth/SavePreAuth`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    saveWarrantyPreAuthMedia = async (params: any) => {
        try {
            const response = await agent.api.post(`/warrantyclaimpreauth/AddMedia`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    deleteWarrantyPreAuthMedia = async (params: any) => {
        try {
            const response = await agent.api.del(`/warrantyclaimpreauth/DeleteMedia`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    downloadWarrantyPreAuthMedia = async (params: any, fileType: string) => {
        try {
            const response = await agent.api.downloadDocument(`/warrantyclaimpreauth/DownloadMedia`, params, fileType);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    cancelPreAuth = async (params: any) => {
        try {
            const response = await agent.api.post(`/warrantyclaimpreauth/CancelPreAuth?preAuthNumber=${params}`, '');
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    deletePreAuth = async (params: any) => {
        try {
            const response = await agent.api.del(`/warrantyclaimpreauth/DeletePreAuth?preAuthNumber=${params}`);
            return response;
        }
        catch (error) {
            throw error;
        }
    }
}